<nav
  *ngIf="!isLoginModalOpen && !isSubscribeModalOpen && !isRestaurantModalOpen && !isFavoriteModalOpen"
  class="w-100 bg-white z-index-10 position-fixed top-0 py-2"
>
  <ng-content></ng-content>
</nav>
